/* eslint-disable react-hooks/exhaustive-deps */
/* eslint-disable no-undef */
/* eslint-disable react-hooks/rules-of-hooks */
import React, { useEffect, useMemo, useRef, useState } from "react";
import { useDispatch } from "react-redux";

import Constant from "../../util/constant";
import CreateUserComponent from "./createUserComponent";
import { useTranslation } from "react-i18next";
import { components } from "react-select";
import { addUser } from "../../store/usersManagement/actions";
import { useNavigate } from "react-router-dom";
import { getDepotsList } from "../../store/depots/actions";
import CustomeOptionLabel from "../../components/customeOptionLabel/customeOptionLabel";
import { Helmet } from 'react-helmet';

/**
 * Component for creating a new user in the users management system.
 * @param {{object}} props - The props object containing necessary data and functions.
 * @returns The JSX element for the CreateUsersManagement component.
 */
const CreateUsersManagement = (props) => {
  const { t } = useTranslation();
  const navigate = useNavigate();
  const dispatch = useDispatch();

  const selectInputRef = useRef();
  const [isroleselect, setIsroleselect] = useState("");
  const [isMobileselect, setIsMobileselect] = useState("");
  const [isMangerDepotName, setIsMangerDepotName] = useState([]);
  const [isDriverDepotName, setIsDriverDepotName] = useState("");
  const [createUserValues, setCreateUserValues] = useState("");
  const [depotData, setDepotData] = useState([]);
  const [loaderButtonShow, setLoaderButtonShow] = useState(false);
  const [fullnametextcount, setFullnametextcount] = useState(0);
  const [emailtextcount, setEmailtextcount] = useState(0);
  const [paynumbertextcount, setPaynumbertextcount] = useState(0);
  const [phoneNumbers, setPhoneNumbers] = useState("-");
  const [phoneNumberError, setphoneNumberError] = useState("");
  const [phoneTouched, setphoneTouched] = useState(false);
  const [sethomeDepot, setHomeDepot] = useState("");

  useEffect(() => {
    getDepotList();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);
  /**
   * Retrieves the list of depots and sets the depot data state.
   * @returns None
   */
  const getDepotList = () => {
    let queryParams = {};
    queryParams.status = Constant.GENERALKEYS.ACTIVE;
    dispatch(
      getDepotsList(
        queryParams,
        (res) => {
          setDepotData(
            res?.data?.map((item) => {
              return {
                ...item,
                label: item?.name,
                value: item?.name,
              };
            })
          );
        },
        (err) => {
          console.log(err);
        }
      )
    );
  };

  /**
   * Handles the form submission by dispatching an action to add a new user.
   * @param {{object}} data - The form data containing the user's information.
   * @returns None
   */
  const handleFormSubmit = (data) => {
  console.log('isMobileselect', isMobileselect);
  console.log('data', data);
    setLoaderButtonShow(true)
    const depotId = [
      isDriverDepotName?.depotid
    ];
    if (isroleselect === Constant.GENERALKEYS.DRIVER) {
      const params = {
        fullname: data?.fullname,
        emailid: data?.email.toLowerCase(),
        payno: data?.paynumber,
        phone: phoneNumbers,
        role: isroleselect,
        allowmobilelogin: true,
        depotid: depotId,
        homedepotid: null,
      };
      dispatch(
        addUser(
          params,
          (res) => {
            setEmailtextcount(0);
            navigate("/usersManagement");
            createUserValues.reset(
              {
                fullname: "",
                email: "",
                paynumber: "",
              },

              setPhoneNumbers(""),
              setIsroleselect(""),
              setIsMobileselect(""),
              setIsDriverDepotName(""),
              setHomeDepot(""),
              setphoneTouched(false),
              setphoneNumberError(""),
              selectInputRef?.current?.clearValue()
            );
            setLoaderButtonShow(false);
          },
          (err) => {
            setLoaderButtonShow(false);
            console.log(err);
          }
        )
      );
    } else {
      const params = {
        fullname: data?.fullname,
        emailid: (data?.email.toLowerCase()),
        payno: data?.paynumber,
        phone: phoneNumbers,
        role: isroleselect,
        allowmobilelogin: isMobileselect === "Yes" ? true : false,
        depotid: isMangerDepotName,
        homedepotid: sethomeDepot,
      };
      dispatch(
        addUser(
          params,
          (res) => {
            navigate("/usersManagement");
            createUserValues.reset(
              {
                fullname: "",
                email: "",
                paynumber: "",
              },

              setPhoneNumbers(""),
              setIsroleselect(""),
              setIsMobileselect(""),
              setIsMangerDepotName(""),
              setHomeDepot(""),
              setphoneTouched(false),
              setphoneNumberError(""),
              selectInputRef?.current.clearValue()
            );
            setLoaderButtonShow(false);
          },
          (err) => {
            setLoaderButtonShow(false);
            console.log(err);
          }
        )
      );
    }
  };

  /**
   * Sets the form values for creating a new user.
   * @param {{object}} form - The form object containing the user details.
   * @returns None
   */
  const createUserFunction = (form) => {
    setCreateUserValues(form);
  };
  /**
   * Event handler for the change event of a radio input in the Roleradio component.
   * Updates the value of the selected role and clears the value of the select input.
   * @param {{Event}} e - The event object.
   * @returns None
   */
  const roleradioChangeHandler = (e) => {
    setIsroleselect(e.target.value);
    selectInputRef.current.clearValue();
  };

  /**
   * Event handler for the change event of a mobile radio button.
   * @param {Event} e - The event object.
   * @returns None
   */
  const mobileradioChangeHandler = (e) => {
    setIsMobileselect(e.target.value);
  };

  const addUserForm = useMemo(
    () => ({
      fullname: {
        name: "fullname",
        validate: {
          required: {
            value: true,
            message: t("FULL_NAME_IS_REQUIRED"),
          },
          pattern: {
            value: Constant.REGEX.NAME,
            message: t("ALLOWED_ONLY_PERIOD_APOSTROPHE_HYPHEN_DASH_AND_SPACES"),
          },
          maxLength: {
            value: 200,
            message: t("ALLOWED_MAX_200_CHARACTERS"),
          },
        },
      },
      email: {
        name: "email",
        validate: {
          required: {
            value: true,
            message: t("EMAIL_ADDRESS_IS_REQUIRED"),
          },
          pattern: {
            value: Constant.REGEX.EMAIL,
            message: t("EMAIL_ADDRESS_IS_INVALID"),
          },
        },
      },
      paynumber: {
        name: "paynumber",
        validate: {
          required: {
            value: true,
            message: t("PAY_NUMBER_IS_REQUIRED"),
          },
          pattern: {
            value: Constant.REGEX.PAYNUMBER,
            message: t("ENTER_5_DIGIT_VALID_PAY_NUMBER"),
          },
        },
      },
      phone: {
        name: "phone",
        validate: {
          required: {
            value: true,
          },
        },
      },
      role: {
        name: "role",
        validate: {
          required: {
            value: true,
          },
        },
      },
      mobileLogin: {
        name: "mobileLogin",
        validate: {
          required: {
            value: isroleselect === "Driver" ? false : true,
          },
        },
      },
      depot: {
        name: "depot",
        validate: {
          required: {
            value: true,
          },
        },
      },
    }),
    [isroleselect]
  );

  const InputOption = ({
    getStyles,
    Icon,
    isDisabled,
    isSelected,
    children,
    innerProps,
    ...rest
  }) => {
    const props = {
      ...innerProps,
    };


    return (
      <components.Option
        {...rest}
        isDisabled={isDisabled}
        isSelected={isSelected}
        getStyles={getStyles}
        innerProps={props}
      >
        <input type="checkbox" checked={isSelected} />
        <label for="checkbox">
          <span></span>
        </label>
        {children}
        {isroleselect === Constant.GENERALKEYS.DRIVER ? (
          ""
        ) : (
          <>
            {isSelected && (
              <div>
                <button
                  type="button"
                  className="sublabel"
                  onClick={(e) => {
                    e.stopPropagation();
                    setHomeDepot(rest?.data?.depotid);
                  }}
                >
                  {sethomeDepot === rest?.data?.depotid ? (
                    <>
                      <div className="HomeDepotActive">
                        <i className="mdi mdi-check"> </i>
                        <span className="sublabelText">{t("HOME_DEPOT")}</span>
                      </div>
                    </>
                  ) : (
                    <>
                      <div className="MarkDepot">
                        <i className="mdi mdi-check"> </i>
                        <span className="sublabelText">
                          {t("MARK_AS_HOME_DEPOT")}
                        </span>
                      </div>
                    </>
                  )}
                </button>
              </div>
            )}
          </>
        )}
      </components.Option>
    );
  };

  const backPageFunction = () => {
    navigate("/usersManagement");
  };

  /**
   * Handles the change event of an input field and updates the character count of the full name text.
   * @param {{Event}} e - The event object triggered by the input field.
   * @returns None
   */
  const handlefullnametextcount = (e) => {
    const value = e.target.value;
    setFullnametextcount(value.length);
  };

  /**
   * Handles the change event of an input field and updates the count of characters in the email text.
   * @param {{Event}} e - The event object representing the change event.
   * @returns None
   */
  const handleEmailtextcount = (e) => {
    const value = e.target.value;
    setEmailtextcount(value.length);
  };
  /**
   * Handles the change event of an input element and updates the count of characters in the value.
   * @param {Event} e - The event object.
   * @returns None
   */
  const handlePaynumbertextcount = (e) => {
    const value = e.target.value;
    setPaynumbertextcount(value.length);
  };

  return (

    <>
    <Helmet>
      <title>Create New User | ScotRail Safety Notice Portal</title>
    </Helmet>
    <CreateUserComponent
      innerPagetitle={t("ADD_USER")}
      addUserForm={addUserForm}
      addUserDepotName={depotData}
      handleFormSubmit={handleFormSubmit}
      isroleselect={isroleselect}
      selectInputRef={selectInputRef}
      roleradioChangeHandler={(e) => {
        roleradioChangeHandler(e);
      }}
      isMobileselect={isroleselect === Constant.GENERALKEYS.DRIVER ? "Yes" : isMobileselect}
      mobileradioChangeHandler={(e) => {
        mobileradioChangeHandler(e);
      }}
      onChangeMangerDepot={(depotData) => {
        if (Array.isArray(depotData)) {
          setIsMangerDepotName(
            depotData.map((opt) => {
              setHomeDepot("");
              return opt?.depotid;
            })
          );
        }
      }}
      isDriverDepotName={isDriverDepotName}
      onChangeDriverDepot={(options) => {
        setIsDriverDepotName(options);
      }}
      isMangerDepotName={isMangerDepotName}
      formatOptionLabel={<CustomeOptionLabel />}
      components={{ Option: InputOption }}
      setPhoneNumbers={(e) => {
        setPhoneNumbers("+" + e);
      }}
      setphoneNumberError={setphoneNumberError}
      phoneNumberError={phoneNumberError}
      setphoneTouched={setphoneTouched}
      phoneTouched={phoneTouched}
      phoneNumbers={phoneNumbers}
      sethomeDepot={sethomeDepot}
      createUserFunction={createUserFunction}
      backPageFunction={backPageFunction}
      loaderButtonShow={loaderButtonShow}
      fullnametextcount={fullnametextcount}
      handlefullnametextcount={handlefullnametextcount}
      emailtextcount={emailtextcount}
      handleEmailtextcount={handleEmailtextcount}
      paynumbertextcount={paynumbertextcount}
      handlePaynumbertextcount={handlePaynumbertextcount}
    />
    </>
  );
};

export default CreateUsersManagement;
